import { pageRoute } from "../routeFactory";

const EdiPlanForeword = () => import("@/views/EdiPlanForeword.vue");
const PoliciesPage = () => import("@/views/PoliciesPage.vue");
const PeoplePage = () => import("@/views/OurPeople.vue");
const WorkplacePage = () => import("@/views/OurWorkplace.vue");
const ServicesPage = () => import("@/views/OurServices.vue");
const PartnershipsPage = () => import("@/views/OurPartnerships.vue");
const AntiRacismPage = () => import("@/views/AntiRacismPage.vue");
const EdiInclusionStrategyPage = () =>
  import("@/views/EdiInclusionStrategy.vue");

const section = "edi-plan";

export const ediPlanChildren = [
  pageRoute({
    path: "edi-foreword",
    name: "EdiForeword",
    component: EdiPlanForeword,
    section,
    bodyClass: "edi-foreword",
    titleKey: "nav.edi-foreword",
  }),
  pageRoute({
    path: "inclusion-policies",
    name: "EdiPolicies",
    component: PoliciesPage,
    section,
    bodyClass: "our-inclusion-policies",
    titleKey: "nav.policies",
  }),
  pageRoute({
    path: "our-people",
    name: "EdiPeople",
    component: PeoplePage,
    section,
    bodyClass: "our-people",
    titleKey: "nav.people",
  }),
  pageRoute({
    path: "our-workplace",
    name: "EdiWorkplace",
    component: WorkplacePage,
    section,
    bodyClass: "our-workplace",
    titleKey: "nav.workplace",
  }),
  pageRoute({
    path: "our-services",
    name: "EdiServices",
    component: ServicesPage,
    section,
    bodyClass: "our-services",
    titleKey: "nav.services",
  }),
  pageRoute({
    path: "our-partnerships",
    name: "EdiPartnerships",
    component: PartnershipsPage,
    section,
    bodyClass: "our-partnerships",
    titleKey: "nav.partnerships",
  }),
  pageRoute({
    path: "antiracism-policies",
    name: "EdiAntiRacism",
    component: AntiRacismPage,
    section,
    bodyClass: "antiracism-policies",
    titleKey: "nav.antiracism",
  }),
  pageRoute({
    path: "inclusion-strategy",
    name: "EdiInclusionStrategy",
    component: EdiInclusionStrategyPage,
    section,
    bodyClass: "inclusion-strategy",
    titleKey: "nav.inclusion",
  }),
];
